(function(){
  if (window.__conceptScripts) return; window.__conceptScripts = 1;
  function currentSize(scope){
    var picker = (scope||document).querySelector('.hdt-product__variant-picker');
    if (!picker) return '';
    var checked = picker.querySelector('input[name="Size"]:checked') || picker.querySelector('input[type=radio]:checked');
    if (checked) return (checked.value || '').trim();
    var uv = picker.querySelector('[update-value]');
    return uv ? uv.textContent.trim() : '';
  }
  var _pj = {};
  function productJson(handle){
    if (!handle) return Promise.resolve(null);
    if (_pj[handle]) return _pj[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    _pj[handle] = fetch(root + 'products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    return _pj[handle];
  }
  function instantVariant(scope){
    var pk = scope.querySelector('hdt-variant-picker'); if (!pk) return;
    var handle = pk.getAttribute('handle'); if (!handle) return;
    var picker = scope.querySelector('.hdt-product__variant-picker') || pk;
    var checkedRadios = pk.querySelectorAll('input[type=radio]:checked');
    var groupNames = {}; pk.querySelectorAll('input[type=radio]').forEach(function(i){ groupNames[i.name] = 1; });
    if (Object.keys(groupNames).length === 1 && checkedRadios[0]) {
      var sz = (checkedRadios[0].value || '').trim();
      pk.querySelectorAll('[update-value]').forEach(function(el){ if (sz && el.textContent !== sz) el.textContent = sz; });
    }
    productJson(handle).then(function(p){
      if (!p || !p.variants) return;
      var names = (p.options || []).map(function(o){ return typeof o === 'string' ? o : o.name; });
      var sel = {};
      picker.querySelectorAll('input[type=radio]:checked').forEach(function(i){ sel[i.name] = i.value; });
      var v = p.variants.find(function(vr){ return names.every(function(nm, idx){ return sel[nm] == null || vr.options[idx] === sel[nm]; }); });
      if (!v) return;
      scope.querySelectorAll('[is="sku"]').forEach(function(el){ var t = v.sku || ''; if (el.textContent !== t) el.textContent = t; });
    });
  }
  function instantAll(){
    document.querySelectorAll('hdt-variant-picker').forEach(function(pk){
      var scope = pk.closest('.hdt-main-product-quick-view') || pk.closest('[class*="secion-main-product"]') || pk.closest('.hdt-product-info__list') || document;
      instantVariant(scope);
    });
  }
  function updateInsize(){
    document.querySelectorAll('.hdt-product__variant-picker').forEach(function(picker){
      var scope = picker.closest('.hdt-main-product-quick-view') || picker.closest('.hdt-product-info__list') || document;
      var checked = picker.querySelector('input[name="Size"]:checked') || picker.querySelector('input[type=radio]:checked');
      var sz = checked ? (checked.value||'').trim() : '';
      var suffix = sz ? (' in size ' + sz) : '';
      scope.querySelectorAll('.pc-insize').forEach(function(s){ if (s.textContent !== suffix) s.textContent = suffix; });
      var qEl = scope.querySelector('.hdt-product__inventory .hdt-stock-status:not([hidden]) [data-quantity]');
      var n = qEl ? parseInt((qEl.textContent||'').replace(/[^0-9]/g,''),10) : NaN;
      var word = (!isNaN(n) && n <= 2) ? ' — almost gone' : ' — selling fast';
      scope.querySelectorAll('.pc-urgency').forEach(function(s){ if (s.textContent !== word) s.textContent = word; });
    });
  }
  function fmtOne(el){
    if (el.querySelector && el.querySelector('.hdt-money')) return;
    var t = el.textContent;
    var nt = t.replace(/Rs\.?\s*/g, '₹').replace(/\s*INR\b/g, '').replace(/(\d)\.00(?!\d)/g, '$1');
    if (nt !== t) el.textContent = nt;
  }
  function fmtMoney(){
    document.querySelectorAll('.hdt-product__price .hdt-money, .hdt-product__price [amount], .hdt-sticky-btn-atc .hdt-money, .hdt-sticky-btn-atc [tag-select] span, .hdt-sticky-btn-atc .hdt-sticky-atc__product-monney').forEach(fmtOne);
  }
  function updateNotify(){
    document.querySelectorAll('.hdt-back-instock').forEach(function(bi){
      if (bi.hasAttribute('hidden')) return;
      var scope = bi.closest('.hdt-main-product-quick-view') || bi.closest('.hdt-product-info__list') || document;
      var sz = currentSize(scope);
      var setTxt = function(el, val){ if (el && el.textContent !== val) el.textContent = val; };
      if (sz) {
        var _sc = ('' + sz).replace(/[<>&"]/g, '');
        var _d = _sc.charAt(0);
        var _html = (_d >= '0' && _d <= '9')
          ? ('Size <span class="pc-sz-fig">' + _d + '</span>' + _sc.slice(1) + ' is sold out.')
          : ('Size ' + _sc + ' is sold out.');
        var h = bi.querySelector('.hdt-product__notify-stock-heading span');
        if (h && h.innerHTML !== _html) h.innerHTML = _html;
      }
      setTxt(bi.querySelector('.hdt-product__notify-stock-subtitle'), "Drop your email and we'll tell you the moment it's back in stock.");
      var email = bi.querySelector('input[type="email"]');
      if (email && email.getAttribute('placeholder') !== 'Your email address') email.setAttribute('placeholder', 'Your email address');
      var btn = bi.querySelector('.contact-form button[type="submit"], .contact-form .hdt-btn');
      if (btn) {
        if (btn.children.length === 0) { setTxt(btn, 'Notify me'); }
        else { var s = btn.querySelector('span'); setTxt(s, 'Notify me'); }
      }
    });
  }
  function wlStock(){
    document.querySelectorAll('.hdt-product__inventory').forEach(function(inv){
      var low = inv.querySelector('.hdt-stock-status[low-stock]:not([hidden]), .hdt-stock-status[low-stock-count]:not([hidden])');
      inv.classList.toggle('wl-lowstock', !!low);
      var oos = inv.querySelector('.hdt-stock-status[out-of-stock]:not([hidden])');
      var list = inv.closest('.hdt-product-info__list');
      if (list) list.classList.toggle('wl-soldout', !!oos);
    });
    document.querySelectorAll('[class*="product_pincode"]').forEach(function(p){
      var item = p.closest('.hdt-product-info__item');
      if (item) item.classList.add('wl-pincode-item');
    });
  }
  function refreshAll(){ updateInsize(); fmtMoney(); updateNotify(); wlStock(); }
  function scheduleRefresh(){ [0,150,400,800,1300].forEach(function(t){ setTimeout(refreshAll, t); }); }
  function hasProductUI(){
    return !!document.querySelector('hdt-variant-picker, .hdt-product__variant-picker, .hdt-back-instock, .hdt-product__inventory');
  }
  function initialRefresh(){
    if (!hasProductUI()) return;
    refreshAll();
    instantAll();
  }

  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('.hdt-product__variant-picker')) { instantAll(); scheduleRefresh(); }
  });
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wl-view-similar]')) {
      var rel = document.querySelector('.hdt-related-products, [id*="related-products"]');
      if (rel) { e.preventDefault(); rel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if (t.closest('.hdt-product__variant-picker label')) { instantAll(); scheduleRefresh(); }
    var code = t.closest('.v-code');
    if (code && code.dataset.bound !== '1') {
      var val = code.getAttribute('data-code') || code.textContent.trim();
      var done = function(){ var o = code.getAttribute('data-label') || val; code.textContent = code.getAttribute('data-copied') || 'Copied ✓'; setTimeout(function(){ code.textContent = o; }, 1500); };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(val).then(done).catch(done); }
      else { var ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select(); try{ document.execCommand('copy'); }catch(err){} document.body.removeChild(ta); done(); }
    }
    if (t.closest('[class*="quick-view"],[class*="quick-add"],[class*="quickview"],[class*="quickadd"]')) {
      [400, 900, 1600].forEach(function(ms){ setTimeout(refreshAll, ms); });
    }
    var fit = t.closest('.pc-sizehead .find');
    if (fit) {
      var s = fit.closest('.hdt-main-product-quick-view') || fit.closest('.hdt-product-info__list') || document;
      var szBtn = null, btns = s.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) { if (/view size chart/i.test(btns[i].textContent || '')) { szBtn = btns[i]; break; } }
      if (!szBtn) { var all = document.querySelectorAll('button'); for (var j = 0; j < all.length; j++) { if (/view size chart/i.test(all[j].textContent || '')) { szBtn = all[j]; break; } } }
      if (szBtn) { e.preventDefault(); szBtn.click(); }
    }
  }, true);

  if (window.MutationObserver) {
    document.querySelectorAll('[class*="secion-main-product"]').forEach(function(sec){
      new MutationObserver(function(){ updateInsize(); updateNotify(); fmtMoney(); wlStock(); }).observe(sec, {childList:true,subtree:true});
    });
    var qvt;
    document.querySelectorAll('#hdt-quick-view-modal, #hdt-quick-add-modal').forEach(function(modal){
      new MutationObserver(function(){ clearTimeout(qvt); qvt = setTimeout(refreshAll, 60); }).observe(modal, {childList:true,subtree:true});
    });
  }
  if (document.readyState !== 'loading') initialRefresh();
  else document.addEventListener('DOMContentLoaded', initialRefresh);
  [400,1000,2000].forEach(function(t){
    setTimeout(function(){ if (hasProductUI()) refreshAll(); }, t);
  });
})();
